import React, { useContext, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { SchoolContext } from '../../context/SchoolContext';
import Card from '../ui/Card';
import Button from '../ui/Button';

const TakeExam = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { assessments } = useContext(SchoolContext);
    const assignment = assessments.find(a => a.id.toString() === id);

    const [answers, setAnswers] = useState({});

    const handleAnswerChange = (questionId, value) => {
        setAnswers(prev => ({ ...prev, [questionId]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically submit the answers to the backend
        console.log('Submitting answers:', answers);
        alert('Exam submitted successfully!');
        navigate('/assessments');
    };

    if (!assignment) {
        return <div>Assignment not found!</div>;
    }

    return (
        <Card title={`Exam: ${assignment.name}`}>
            <form onSubmit={handleSubmit}>
                <div className="space-y-6">
                    {assignment.questions.map((q, index) => (
                        <div key={q.id || index}>
                            <label className="block text-lg font-semibold mb-2">{index + 1}. {q.text}</label>
                            <textarea
                                rows="3"
                                className="w-full p-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
                                placeholder="Your answer here..."
                                onChange={e => handleAnswerChange(q.id || index, e.target.value)}
                            />
                        </div>
                    ))}
                </div>
                <Button type="submit" className="mt-6">Submit Exam</Button>
            </form>
        </Card>
    );
};

export default TakeExam;
